import React, { CSSProperties } from "react";
import { Link } from "react-router-dom";

import { Button } from "@/design-system/components/Button/Button";
import unauthorizedImage from "@/img/restricted_area.png";

const Unauthorized: React.FC<{
  message: string;
  containerStyle?: CSSProperties;
}> = ({ message, containerStyle = {} }) => {
  return (
    <div
      className="flex flex-col items-center pt-[150px] text-center"
      style={containerStyle}
    >
      <img
        className="mb-4"
        alt="Unauthorized"
        src={unauthorizedImage}
        height="auto"
        width={273}
      />
      <h3 className="mb-2">
        You do not have permission to perform this action
      </h3>
      <p className="m-5 w-[500px]">{message}</p>
      <Link to="/settings/team">
        <Button>View Admins</Button>
      </Link>
    </div>
  );
};

export default Unauthorized;
